import { styled, keyframes } from '@mui/material/styles';
import { Box, Typography, List, ListItemButton } from '@mui/material';

const shimmerTranslate = keyframes`
  0% { transform: translateX(-180%); }
  100% { transform: translateX(180%); }
`;

const stopShimmer = keyframes`
  to { animation: none; }
`;

export const ListSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  textAlign: 'center',
  height: 45,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
}));

export const ListBox = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  boxSizing: 'border-box',
}));

export const ScrollableListBox = styled(Box)({
  overflowY: 'auto',
  width: '100%',
});

export const DirButtonContainer = styled('div')(({ theme }) => ({
  flexDirection: 'column',
  margin: '4px 8px 0px',
  width: 100,
  alignItems: 'center',
  display: 'flex',

  '& p[type="label_medium"]': {
    textAlign: 'center',
    color: theme.palette.secondary.main,
  },
}));

export const ListItemRow = styled(ListItemButton)(({ theme }) => ({
  borderTop: `${theme.palette.action.disabled} solid 1px`,
  position: 'relative',
}));

export const MarginLeftList = styled(List)(({ theme }) => ({
  marginLeft: theme.spacing(2),
}));

export const MarginRightWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

export const ShimmerWrap = styled('span', {
  shouldForwardProp: (prop) => prop !== 'shimmerOn',
})(({ theme, shimmerOn }) => ({
  position: 'relative',
  borderRadius: '50%',
  overflow: 'hidden',
  contain: 'layout paint',
  display: 'inline-flex',

  '& .MuiSvgIcon-root': {
    position: 'relative',
    zIndex: 1,
    color: theme.palette.common.white,
  },

  '&::before': shimmerOn
    ? {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '60%',
        height: '100%',
        background:
          'linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.65) 50%, rgba(255,255,255,0) 100%)',
        filter: 'blur(1px)',
        transform: 'translate3d(-180%, 0, 0)',
        willChange: 'transform',
        backfaceVisibility: 'hidden',
        pointerEvents: 'none',
        zIndex: 0,
        animation: `${shimmerTranslate} 1.6s ease-in-out infinite, ${stopShimmer} 60s forwards`,
      }
    : undefined,

  '@media (prefers-reduced-motion: reduce)': {
    '&::before': { animation: 'none !important' },
  },
}));
